//import mic from '../../images/mic.png'

export const homeObj1 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'A New Music Platform',
    headLine: 'Streaming and NFT Music Purchases all in One Place ',
    description: 'Stream and buy music on the XRPL, through our streaming platform and digital music store.',
    imgStart: false,
    alt: 'A New Music Platform',
    dark: true,
    primary: true,
    darkText: false,
    isCircular: false
}
export const homeObj2 = {
    id: 'main',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'A Pay Per Stream Web Monetization Service',
    headLine: 'A Product of Sonar Muse ',
    description: 'Claim a month free subscription NFT coupon.',
    imgStart: false,
    img: '../../images/swərl_illustration_logo.png',
    alt: '',
    buttonLabel: 'Claim',
    to: '/access/signup',
    dark: false,
    primary: false,
    darkText: true,
    isCircular: false
}
export const homeObj3 = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join Our Platform',
    headLine: 'Creating an account is fast and easy',
    description: 'Get everything set up and ready by signing in with your Xumm Wallet ',
    buttonLabel: 'Sign Up Now',
    to:'/',
    imgStart: false,
    img: 'https://pbs.twimg.com/profile_images/1280832346611167236/1sQA2Dn9_400x400.jpg',
    alt: 'mic',
    dark: false,
    primary: false,
    darkText: true,
    isCircular: false
}

